module.exports = __webpack_public_path__ + "static/media/cover-product-3.fe0bbe32.jpg";